import { memo } from 'react';
import { Channel } from '../../types/Channel.interface';
import SortedSelect, { SortedSelectProps } from './SortedSelect';

export type ChannelSelectProps = {
    selectedChannel: number;
    channelOptions: Channel[];
} & Omit<SortedSelectProps<Channel>, 'selectedValue' | 'options'>;

function ChannelSelect({ selectedChannel, channelOptions, onChange, label = 'Channel', ...props }: ChannelSelectProps) {
    return (
        <SortedSelect
            selectedValue={selectedChannel}
            options={channelOptions}
            onChange={onChange}
            label={label}
            {...props}
        />
    );
}

export default memo(ChannelSelect);
